import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { StateWithSeo } from '@seo/data-access';
import { CustomPageMeta } from '@shared/models';
import { ActivatedRoutesService, ProductScope, ProductService } from '@spartacus/core';
import { Observable, combineLatest, distinctUntilChanged, filter, map, switchMap } from 'rxjs';
import { SeoPageService } from './seo-page.service';

@Injectable({ providedIn: 'root' })
export class SeoReviewsPageService extends SeoPageService {
  private productCode$ = this.activatedRoutesService.routes$.pipe(
    filter<ActivatedRouteSnapshot[]>(Boolean),
    map((routes) => routes[routes.length - 1].paramMap.get('productCode')),
    filter(Boolean),
    distinctUntilChanged(),
  );

  private product$ = this.productCode$.pipe(
    switchMap((productCode) => this.productService.get(productCode, ProductScope.DETAILS)),
  );

  constructor(
    store: Store<StateWithSeo>,
    private activatedRoutesService: ActivatedRoutesService,
    private productService: ProductService,
  ) {
    super(store);
  }

  getSeoPage(): Observable<CustomPageMeta | null> {
    return combineLatest({
      product: this.product$,
      seoData: super.getSeoPage(),
    }).pipe(
      map(({ seoData, product }) => {
        if (seoData?.breadcrumbs) {
          seoData.breadcrumbs = [
            { label: 'главная', link: '/' },
            { label: product.name ?? '', link: product.url ?? '/' },
            ...seoData.breadcrumbs.slice(-1),
          ];
        }

        return seoData;
      }),
    );
  }
}
